import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Link } from 'react-router-dom'
import { ContentHeader, Loader } from '@components';
import { TableHeader, Pagination, Search } from '@app/components/react-data-table';
import Button from 'react-bootstrap/Button';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getPermission, getPermissionById, deletePermission } from '../../services/permission';
import AddPermission from './AddPermission';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import { getPortals } from '../../services/portal';

const Permissions = () => {
    const componentRef = useRef();
    const [listData, setListData] = useState([]);
    const [portalData, setPortalData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isPopLoading, setPopLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "" });
    const ITEMS_PER_PAGE = 25;
    const [optionData, setOptionData] = useState('');
    const [getId, setId] = useState(0); 
    const [fillData, setFillData] = useState({
        uid: '',
        name: '',
        category: '',
        portal: ''
    });
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (id: number) => {
        if (id !== 0) {
            setId(id);
            getPermissionDetail(id);
        } else {
            setFillData({
                uid: Math.random().toString(36).slice(2, 20),
                name: '',
                category: '',
                portal: ''
            });
            setOptionData('');
            setId(0);
        }

        setShow(true);
    }
    const colomns = [
        { name: "Name", field: "name", sortable: false },
        { name: "Category", field: "category", sortable: false },
        { name: "Portal", field: "portal_name", sortable: false },
        { name: "Action", field: "", sortable: false, className: 'td-center d-print-none' }
    ];

    const resultData = useMemo(() => {
        let computedResults = listData;
        if (search) {
            computedResults = computedResults.filter(
                data => data.category.toLowerCase().includes(search.toLowerCase()) || data.portal_name.toLowerCase().includes(search.toLowerCase())
            );
        }
        setTotalItems(computedResults.length);
        //Sorting listData
        if (sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            computedResults = computedResults.sort(
                (a, b) =>
                    reversed * a[sorting.field].localeCompare(b[sorting.field])
            );
        }
        //Current Page slice
        return computedResults.slice(
            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
        );
    }, [listData, currentPage, search, sorting]);


    useEffect(() => {
        setSearch("");
        getList();
        getPostalList();
    }, [])

    const getPermissionDetail = (id: any) => {
        setPopLoading(true);
        getPermissionById(id).then(function (res: any) {
            const resp = res.data;
            setPopLoading(false);
            if (res.status === 200 && resp.Acknowledge == 1) {
                let respData = resp.record;
                setFillData({
                    uid: Math.random().toString(36).slice(2, 20),
                    name: respData.name,
                    category: respData.category,
                    portal: respData.portal_id
                });
            }
        }).catch(err => {
            setPopLoading(false);
            toast.error(err.response.data.FullMessage !== 'undefied' ? err.response.data.FullMessage : 'Internal Server Error!');
        });
    };

    const getPostalList = (filter = "") => {
        getPortals(filter).then(function (res) {
            const resp = res.data;
            if (resp.Acknowledge == 1 && resp.records) {
                let data: any = [];
                resp.records.map((val: any, i: any) => {
                    data[i] = {
                        id: val.id,
                        name: val.name
                    };
                });
                setPortalData(data);
            }
        }).catch(err => {
            return false;
        });
    };

    const getList = (filter = "") => {
        setLoading(true);
        getPermission(filter).then(function (res) {
            const resp = res.data;
            if (resp.Acknowledge == 1 && resp.records) {
                let data: any = [];
                resp.records.map((val: any, i: any) => {
                    data[i] = {
                        id: val.id,
                        name: val.name,
                        category: val.category,
                        portal_name: val.portal_name
                    };
                });
                setListData(data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            return false;
        });
    };

    const deleteItem = (paramId: number) => {
        confirmAlert({
            message: 'Are you sure you want to delete this record?',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    setLoading(true);
                    deletePermission(paramId).then((result: any) => {
                        setLoading(false);
                        if (result.data.Acknowledge == '1') {
                            getList();
                            toast.success('Record has been deleted successfully.');
                        }
                    }).catch((err) => {
                        setLoading(false);
                        toast.error("Internal server error on delete.");
                    });
                }

            },
            {
                label: 'No',
            }]
        });
    }

    return (
        <>
            <ContentHeader title="Permissions" />
            <section className="content">
                <div className="container-fluid">
                    <div className="col-12">
                        <div className="card order_listing future_delivery_listing">
                            <div className="card-body">
                                <div className='table-warp-search-pagination'>
                                    <div className='d-flex custom-pagination justify-content-between'>
                                        <Search
                                            onSearch={value => {
                                                setSearch(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                        <Button className="btn btn-info btn_new_order btn_txt" onClick={() => handleShow(0)}>
                                            Add Permission
                                        </Button>
                                    </div>
                                    <div className='listing_table_wrap med_table_wrap' ref={componentRef}>
                                        <h3 className='d-none d-print-block m-2'>Permissions</h3>
                                        <table className="cell-border table table-bordered table-striped" style={{ width: '100%' }} >
                                            <TableHeader
                                                headers={colomns}
                                                onSorting={(field, order) =>
                                                    setSorting({ field, order })
                                                }
                                            />
                                            <tbody>
                                                {resultData.length > 0 ? resultData.map((row: any, podidx: number) => (
                                                    <tr key={podidx}>
                                                        <td className='td-left'>{row.name.toUpperCase()}</td>
                                                        <td className='td-left'>{row.category.toUpperCase()}</td>
                                                        <td className='td-left'>{row.portal_name}</td>
                                                        <td style={{ width: '10%', textAlign: 'center' }} className='d-print-none'>
                                                            <a className="btn edit_btn p-0 pr-2" onClick={() => handleShow(row.id)} title="Edit"><i className="nav-icon far fa-edit"></i></a>
                                                            <button onClick={() => deleteItem(row.id)} title="Delete" className="btn delete_btn p-0"><i className="nav-icon far fa-trash-alt"></i></button>
                                                        </td>
                                                    </tr>
                                                ))
                                                    : <tr><td style={{ textAlign: 'center' }} colSpan="8">No record found.</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        total={totalItems}
                                        itemsPerPage={ITEMS_PER_PAGE}
                                        currentPage={currentPage}
                                        onPageChange={page => setCurrentPage(page)}
                                    />
                                </div>
                            </div>
                            <Loader isLoading={isLoading} />
                        </div>
                    </div>
                </div>
            </section >
            <AddPermission portalData={portalData} isPopLoading={isPopLoading} getId={getId} setOptionData={setOptionData} optionData={optionData} fillData={fillData} setFillData={setFillData} show={show} loadList={getList} setShow={setShow} handleClose={handleClose} />
        </>
    );
};

export default Permissions;
